import cn from 'classnames';
import type React from 'react';
import { memo } from 'react';
import { usePlatformSettings } from '@shared/hooks';
import type { ActiveTabType } from '@shared/types/common';
import { ImageWithSkeleton } from '@shared/ui/img-with-skeleton/ui.tsx';
import type { ModerationStatus } from '@src/library/models/events.ts';
import st from './styles.module.scss';

interface Props {
  isOpened: boolean;
  isAuthor: boolean;
  isPublished: boolean;
  modStatus: ModerationStatus;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  imgSrc?: string;
  activeTab?: ActiveTabType;
  wrapperClassName?: string;
  wrapperWithStatusClassName?: string;
  imageClassName?: string;
  imageWithStatusClassName?: string;
}

export const OpenIndicatorWithImage = memo(
  ({
    isAuthor,
    activeTab,
    isOpened,
    isPublished,
    modStatus,
    onClick,
    imgSrc,
    wrapperClassName,
    imageClassName,
    imageWithStatusClassName,
    wrapperWithStatusClassName,
  }: Props) => {
    const { moderation } = usePlatformSettings();

    const getStyles = () => {
      let style = st.hidden;

      if (moderation) {
        // if (!isPublished && (modStatus.abbr_status === 'N' || modStatus.abbr_status === 'A')) {
        //   style = st.hidden;
        // }

        if (isPublished && modStatus.abbr_status === 'N') {
          style = st.moderation;
        }

        if (modStatus.abbr_status === 'D') {
          style = st.rejected;
        }
      } else {
        if (activeTab === 'my') {
          isPublished && (style = st.published);
        } else if (activeTab === 'all' || 'favorite') {
          if (!isOpened && !isAuthor) {
            style = st.noOpen;
          }
        }
      }

      return style;
    };

    const style = getStyles();
    return (
      <div
        className={cn(
          st.wrapper,
          wrapperClassName,
          style !== st.hidden ? wrapperWithStatusClassName || st.withStatus : undefined
        )}
        onClick={onClick}
      >
        {style !== st.hidden && <div className={cn(st.status, style)}></div>}
        <ImageWithSkeleton
          className={cn(
            st.image,
            imageClassName,
            style !== st.hidden ? imageWithStatusClassName || st.imgWithStatus : undefined
          )}
          src={imgSrc}
          alt={imgSrc}
        />
        {/*<img*/}
        {/*  className={cn(st.image, style !== st.hidden ? st.imgWithStatus : undefined)}*/}
        {/*  src={imgSrc}*/}
        {/*  alt={imgSrc}*/}
        {/*/>*/}
      </div>
    );
  }
);
